import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {PutBank, PutBankResponse, PutBankParams} from 'domain/usecases';

export class RemoteRefundPutBank implements PutBank {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PutBankResponse>,
	) {}

	async put(params?: PutBankParams): Promise<PutBankResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'put',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
